import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;

	@media ${Breakpoints.tablet} {
		padding: 0 1.5rem;

		&.gutterBottom {
			border-bottom: 1px solid var(--border-color);
			padding-bottom: 2rem;
		}
	}
`;

export const Stage = styled.div`
	display: flex;
	align-items: center;
	text-align: center;
	position: relative;
	border: 1px solid var(--border-color);
	padding: 0.5rem;
	background: var(--white);
	border-right: unset;
	border-left: unset;
	transition: all 0.3s;
	cursor: default;

	:not(:first-of-type) {
		padding-left: 3rem;

		body[dir='rtl'] & {
			padding-right: 3rem;
			padding-left: unset;
		}
	}

	:first-of-type {
		body[dir='ltr'] & {
			border-top-left-radius: 3rem;
			border-bottom-left-radius: 3rem;
			border-left: 1px solid var(--border-color) !important;
		}

		body[dir='rtl'] & {
			border-top-right-radius: 3rem;
			border-bottom-right-radius: 3rem;
			border-right: 1px solid var(--border-color) !important;
		}
	}

	:last-of-type {
		body[dir='ltr'] & {
			border-top-right-radius: 3rem;
			border-bottom-right-radius: 3rem;
			border-right: 1px solid var(--border-color) !important;
		}

		body[dir='rtl'] & {
			border-top-left-radius: 3rem;
			border-bottom-left-radius: 3rem;
			border-left: 1px solid var(--border-color) !important;
		}
	}

	:not(:last-of-type)::after {
		content: ' ';
		display: block;
		width: 0;
		height: 0;
		border-top: 2.28rem solid transparent;
		border-bottom: 2.28rem solid transparent;
		border-left: 2.1rem solid var(--white);
		position: absolute;
		bottom: 0px;
		z-index: 2;
		right: -2rem;

		body[dir='rtl'] & {
			right: unset;
			left: -2rem;
			border-right: 2.1rem solid var(--white);
			border-left: unset;
		}
	}

	:not(:last-of-type):before {
		content: ' ';
		display: block;
		width: 0;
		height: 0;
		border-top: 2.28rem solid transparent;
		border-bottom: 2.28rem solid transparent;
		border-left: 2.1rem solid var(--border-color);
		position: absolute;
		bottom: 0px;
		z-index: 1;
		right: -2.2rem;

		body[dir='rtl'] & {
			right: unset;
			left: -2.2rem;
			border-right: 2.1rem solid var(--border-color);
			border-left: unset;
		}
	}

	&.clickable {
		cursor: pointer;
	}
`;
export const StageMobile = styled.div`
	align-items: space-between;
	justify-content: space-between;
	text-align: left;
	display: flex;
	border: none;

	> span.active.typography {
		margin: 0;
	}
	> span.name.typography {
		margin: 0;
	}
`;

export const MobilePageNumber = styled.div`
	display: flex;
`;

export const MobileOuterDiv = styled.div`
	display: flex;
	flex-direction: column;
	text-align: left;
	border: none;
	margin: auto;
	width: -webkit-fill-available;

	body[dir='rtl'] & {
		text-align: right;
	}

	.description {
		margin: 0.5rem 0;
	}
`;

export const DivContainer = styled.div`
	margin-top: 1rem;
	border-radius: 1rem;
	width: 100%;
	height: 5px;
	background-color: var(--content-4);
	border: 1px solid var(--content-4);
	transition: all 0.3s;
	opacity: 1;

	&.active {
		opacity: 1;
		background-color: var(--blue);
		border: 1px solid var(--blue);
	}
	&.completed {
		background-color: var(--green-60);
		border: 1px solid var(--green-60);
	}
`;
export const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	width: 3.5rem;
	height: 3.5rem;
	color: var(--content-4);
	background-color: var(--background-3);
	border: 1px solid var(--border-color);
	transition: all 0.3s;
	opacity: 1;

	.icon {
		font-size: 1.6rem !important;
	}

	&.active {
		opacity: 1;
		color: var(--alwaysWhiteColor);
		background-color: var(--blue);
		border: 1px solid var(--blue);

		svg {
			color: var(--alwaysWhiteColor);
		}
	}
	&.completed {
		background-color: var(--green-60);
		border: 1px solid var(--green-60);
		svg {
			color: var(--alwaysWhiteColor);
		}
	}
`;

export const LabelText = css`
	transition: all 0.3s;
	margin: 0 1rem;
	top: 5.5rem;

	@media ${Breakpoints.tablet} {
		top: -2.2rem;
		max-width: 10rem;
	}
`;

export const MobileWizardContainer = styled.div`
	display: none;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background-color: var(--white);
	padding: 1.5rem 0.5rem;
	border-top: 1px solid var(--border-color);

	@media ${Breakpoints.tablet} {
		display: flex;
		border-right: 1px solid var(--border-color);
		border-left: 1px solid var(--border-color);
		border-top-right-radius: var(--small-border-radius);
		border-top-right-radius: var(--small-border-radius);
	}
`;
